<template>
  <div>
    <div style="display: flex; align-items: center;">
      <!--      <img :src="srcurl" alt="验证码图片" style="width: 100px; height: 40px; margin-right: 10px;" @click="getsrcuel" />-->
      <!--      <el-input type="text" v-model="verificationCode" placeholder="请输入验证码"-->
      <!--        style="width: 150px; height: 40px; margin-right: 10px;" />-->
      <div class="select-container">
        <el-select v-model="selectedOptions" multiple collapse-tags collapse-tags-tooltip
          :popper-class="'custom-multiselect'" style="width: 300px;" value-key="id" placeholder="请选择客户"
          @change="handleSelectChange">
          <!-- 全选选项 -->
          <el-option :key="'select-all'" :label="selectAllLabel" :value="selectAllItem" />
          <!-- 普通选项 -->
          <el-option v-for="item in clientList" :key="item.id" :label="item.khname" :value="item" />
        </el-select>

      </div>

      <div class="select-container">
        <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="select-container">
        <el-select v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="query">查询</el-button>
      <el-button type="primary" @click="gettheout">数据导出</el-button>
    </div>
    <el-card class="data-card">
      <el-table ref="table" :data="responseResultslist" sortable="custom" @sort-change="soltHandle" row-key="uid"
        :tree-props="{ children: 'children' }" v-loading="loading" border max-height="750" max-width="250"
        :default-sort="{ prop: 'date', order: 'descending' }">

        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="id" label="广告主ID"></el-table-column>
        <el-table-column prop="account" label="广告主名称"></el-table-column>
        <el-table-column prop="display_name" label="广告主账号"></el-table-column>
        <el-table-column prop="category" label="行业分类"></el-table-column>
        <el-table-column prop="belongs" label="所属子账户"></el-table-column>
        <el-table-column prop="impression" sortable label="展现数"></el-table-column>
        <el-table-column prop="click" sortable label="点击数"></el-table-column>
        <el-table-column prop="click_through_rate" sortable label="点击率">
          <!-- <template slot-scope="scope">
            {{ scope.row.click == 0 || scope.row.impression == 0 ? 0 : ((scope.row.click / scope.row.impression) *
              100).toFixed(2) }}%
          </template> -->
          <template slot-scope="scope">
            {{ scope.row.click_through_rate }}%
          </template>
        </el-table-column>
        <el-table-column prop="total_consumption" sortable label="总消费">
          <template slot-scope="scope">
            {{ scope.row.total_consumption }}
          </template>
        </el-table-column>
        <el-table-column prop="cash_consumption" sortable label="现金消费">
          <template slot-scope="scope">
            {{ scope.row.cash_consumption }}
          </template>
        </el-table-column>
        <el-table-column prop="coupon" sortable label="优惠券消费">
          <template slot-scope="scope">
            {{ (scope.row.coupon / 100).toFixed(2) }}
          </template>

        </el-table-column>
        <el-table-column prop="click_onprice" sortable label="点击单价">
          <!-- <template slot-scope="scope">
            ￥{{ (((scope.row.cost / 100) / scope.row.click)).toFixed(22) }}
          </template> -->
        </el-table-column>
        <el-table-column prop="thousand_impressions_consumption" sortable label="千次展现消费">
          <!-- <template slot-scope="scope">
            ￥{{ scope.row.cost == 0 || scope.row.impression == 0 ? 0 : (((scope.row.cost / 100) / scope.row.impression) *
              1000).toFixed(2) }}
          </template> -->
        </el-table-column>
        <el-table-column prop="api_conversion_target" sortable label="转化目标总数"></el-table-column>
        <el-table-column prop="api_conversion_target_rate" sortable label="转化目标总数转化率">
          <template slot-scope="scope">
            {{ scope.row.api_conversion_target_rate }}%
          </template>
        </el-table-column>
        <el-table-column prop="api_conversion_target_cost" sortable label="转化目标总数成本"></el-table-column>
        <el-table-column prop="api_app_active" sortable label="激活数"></el-table-column>
        <el-table-column prop="api_app_active_rate" sortable label="激活转化率"></el-table-column>
        <el-table-column prop="api_app_active_cost" sortable label="激活成本"></el-table-column>
        <el-table-column prop="api_app_lahuo" sortable label="首次拉活"></el-table-column>
        <el-table-column prop="api_app_lahuo_rate" sortable label="首次拉活转化率">
          <template slot-scope="scope">
            {{ scope.row.api_app_lahuo_rate }}%
          </template>
        </el-table-column>
        <el-table-column prop="api_app_lahuo_cost" sortable label="首次拉活成本"></el-table-column>
        <el-table-column prop="api_app_keyaction" sortable label="关键行为"></el-table-column>
        <el-table-column prop="api_app_keyaction_rate" sortable label="关键行为转化率"></el-table-column>
        <el-table-column prop="api_app_keyaction_cost" sortable label="关键行为成本"></el-table-column>
        <el-table-column prop="api_app_retention" sortable label="次留"></el-table-column>
        <el-table-column prop="api_app_retention_rate" sortable label="次留率"></el-table-column>
        <el-table-column prop="api_app_retention_cost" sortable label="次留成本"></el-table-column>
        <!--        666-->
      </el-table>
    </el-card>
    <el-dialog title="数据导出" :visible.sync="outerVisible">
      <div v-if="value == '子账户'">
        <el-button type="primary" @click="exportExcel2">子账户导出</el-button>
        <!-- <el-button type="primary" @click="exportExcel">列表导出</el-button> -->
      </div>
      <div v-else>
        <el-button type="primary" @click="exportExcel2">子账户导出</el-button>
        <el-button type="primary" @click="exportExcel">列表导出</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
  data() {
    return {
      userId: '',
      options: [{
        value: '子账户',
        label: '子账户'
      }, {
        value: '客户层',
        label: '客户层'
      },],
      value: '',
      outerVisible: false,
      value1: [],
      verificationCode: "",
      selectedDate: "",
      srcurl: "",
      selectedOption1: '',        // 下拉框1选中值
      selectedOption2: '',        // 下拉框2选中值
      selectedOptions: [],
      // 全选特殊对象（避免与正常数据冲突）
      selectAllItem: { isSelectAll: true },
      selectAllLabel: "不限",
      clientList: [],
      responseResults: [],// 新增用于存储响应结果,
      responseResultslist: [],
      responseResultslistchildren: [],
      // 下拉框选项数据
      options1: [
        { value: 'option1', label: '选项一' },
        { value: 'option2', label: '选项二' },
        { value: 'option3', label: '选项三' }
      ],
      //
      options2: [
        { value: 'category1', label: '分类一' },
        { value: 'category2', label: '分类二' },
        { value: 'category3', label: '分类三' },
        { value: 'category4', label: '分类四' }
      ],
      loading: false,
      summaryData: {
        id: 1,
      }
    };
  },
  created() {
    this.userId = this.$route.query.userId

    if (!this.userId) {
      // 使用Element UI的消息提示
      this.$message.warning('您得先登录')

      // 设置延迟跳转让用户看到提示
      setTimeout(() => {
        // 重定向到登录页面（外部链接）
        window.location.href = 'https://control.zjwec.cn/page/end/login.html'
      }, 1500)  // 1.5秒后跳转

      // 终止后续执行
    }
    // this.showLibrarySelector();
    this.getUlist()
    axios.get('https://login.aiclk.com/get/captcha', {
      responseType: 'blob',
      params: { timestamp: Date.now() }
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'image/png' });
        this.srcurl = URL.createObjectURL(blob);
        // console.log(this.captchaUrl);
        // ...
      })
      .catch(error => {
        console.error('获取验证码失败:', error);
        // ...
      })
      .finally(() => {
        // this.loading = false;
      });

  },

  methods: {

    soltHandle(column) {
      // 1. 分离固定行和可排序行（保持对象引用）
      const fixedRow = this.responseResultslist.find(r => r.display_name === "总计");
      const sortableData = this.responseResultslist.filter(r => r !== fixedRow);

      // 2. 执行排序（创建新数组）
      const sorted = [...sortableData].sort((a, b) => {
        const valA = a[column.prop];
        const valB = b[column.prop];

        // 改进的数字解析函数
        const toNumber = (v) => {
          if (v == null) return 0;
          if (typeof v === 'number') return v;

          // 处理货币格式 (￥1,234.56)
          if (typeof v === 'string' && v.includes('￥')) {
            return parseFloat(v.replace(/[^\d.-]/g, ''));
          }

          // 处理百分比 (12.34%)
          if (typeof v === 'string' && v.includes('%')) {
            return parseFloat(v);
          }

          // 处理常规数字字符串，可能包含逗号
          if (typeof v === 'string' && /[0-9,.]/.test(v)) {
            return parseFloat(v.replace(/,/g, ''));
          }

          // 其他情况返回原始值
          return v;
        };

        const cmpA = toNumber(valA);
        const cmpB = toNumber(valB);

        // 改进的比较逻辑，确保数字比较
        if (typeof cmpA === 'number' && typeof cmpB === 'number') {
          return column.order === 'descending' ? cmpB - cmpA : cmpA - cmpB;
        }

        // 非数字比较保持原逻辑
        return column.order === 'descending'
          ? cmpB > cmpA ? 1 : -1
          : cmpA > cmpB ? 1 : -1;
      });

      // 3. 合并并更新数据
      this.responseResultslist = fixedRow ? [fixedRow, ...sorted] : [...sorted];

      // 4. 禁用ElementUI内置排序
      this.$nextTick(() => {
        const table = this.$refs.table;
        if (table) {
          table.clearSort();
          table.doLayout();
        }
      });
    },


    gettheout() {
      this.outerVisible = true
    },
    query() {
      // this.getsrcuel()
      // 在这里编写查询逻辑，比如发送请求，获取数据等


      if (this.selectedOptions.length <= 0) {
        this.$message.info("请先选择数据")
        return false
      }
      console.log(this.value1.length === 0)

      if (this.value1.length === 0) {
        this.$message.info("请先选择日期")
        return false
      }

      this.fetchCookieData()

    },
    formatDate(dateStr) {

      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    flattenData(list) {
      let result = []
      list.forEach(item => {
        result.push(item)
        // if (item.children && item.children.length) {
        //   result = result.concat(this.flattenData(item.children))
        // }
      })
      return result
    },

    exportExcel() {
      const XLSX = require('xlsx')
      const FileSaver = require('file-saver')

      // 完整列配置（必须与表格列顺序严格一致）
      const columns = [
        { label: '广告主ID', key: 'id' },
        { label: '广告主名称', key: 'account' },
        { label: '广告主账号', key: 'display_name' },
        { label: '行业分类', key: 'category' },
        { label: '所属子账户', key: 'belongs' },
        { label: '展现数', key: 'impression' },
        { label: '点击数', key: 'click' },
        {
          label: '点击率',
          format: (row) => {
            const click = Number(row.click) || 0
            const impression = Number(row.impression) || 0
            return impression ? ((click / impression) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '总消费',
          format: (row) => (Number(row.cost) / 100).toFixed(2)
        },
        {
          label: '现金消费',
          format: (row) => (Number(row.cash) / 100).toFixed(2)
        },
        {
          label: '优惠券消费',
          format: (row) => (Number(row.coupon) / 100).toFixed(2)
        },
        {
          label: '点击单价',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const click = Number(row.click) || 0
            return click ? (cost / click).toFixed(2) : 0.00
          }
        },
        {
          label: '千次展现消费',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const impression = Number(row.impression) || 0
            return impression ? ((cost / impression) * 1000).toFixed(2) : 0.00
          }
        },
        // 转化目标相关列
        { label: '转化目标总数', key: 'api_conversion_target' },
        {
          label: '转化目标总数转化率',
          format: (row) => {
            const target = Number(row.api_conversion_target) || 0
            const click = Number(row.click) || 0
            return click ? ((target / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '转化目标总数成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const target = Number(row.api_conversion_target) || 0
            return target ? (cost / target).toFixed(2) : 0.00
          }
        },
        // 激活相关列
        { label: '激活数', key: 'api_app_active' },
        {
          label: '激活转化率',
          format: (row) => {
            const active = Number(row.api_app_active) || 0
            const click = Number(row.click) || 0
            return click ? ((active / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '激活成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const active = Number(row.api_app_active) || 0
            return active ? (cost / active).toFixed(2) : 0.00
          }
        },
        // 首次拉活相关列
        { label: '首次拉活', key: 'api_app_lahuo' },
        {
          label: '首次拉活转化率',
          format: (row) => {
            const lahuo = Number(row.api_app_lahuo) || 0
            const click = Number(row.click) || 0
            return click ? ((lahuo / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '首次拉活成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const lahuo = Number(row.api_app_lahuo) || 0
            return lahuo ? (cost / lahuo).toFixed(2) : 0.00
          }
        },
        // 关键行为相关列
        { label: '关键行为', key: 'api_app_keyaction' },
        {
          label: '关键行为转化率',
          format: (row) => {
            const action = Number(row.api_app_keyaction) || 0
            const click = Number(row.click) || 0
            return click ? ((action / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '关键行为成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const action = Number(row.api_app_keyaction) || 0
            return action ? (cost / action).toFixed(2) : 0.00
          }
        },
        // 次留相关列
        { label: '次留', key: 'api_app_retention' },
        {
          label: '次留率',
          format: (row) => {
            const retention = Number(row.api_app_retention) || 0
            const click = Number(row.click) || 0
            return click ? ((retention / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '次留成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const retention = Number(row.api_app_retention) || 0
            return retention ? (cost / retention).toFixed(2) : 0.00
          }
        }
      ]

      const flatten = (data) => {
        return data.reduce((acc, item) => {
          acc.push(item);
          return acc;
        }, []);
      };

      try {
        if (!this.responseResultslist.length) {
          this.$message.warning('没有可导出的数据')
          return
        }

        // 处理数据行
        const data = flatten(this.responseResultslist).map(row =>
          columns.reduce((obj, col) => {
            let value = col.format
              ? col.format(row)
              : row[col.key]

            // 统一处理特殊字符
            if (typeof value === 'string') {
              value = value
                .replace(/"/g, '""')
                .replace(/[\r\n]/g, ' ')
            }

            // 确保非百分比数字值以数字形式存储
            if (typeof value === 'string' && !value.includes('%') && !isNaN(value) && value.trim() !== '') {
              value = Number(value);
            }

            obj[col.label] = value
            return obj
          }, {})
        )

        // 生成工作表
        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '广告数据')

        // 设置列宽
        ws['!cols'] = columns.map(() => ({ wch: 18 }))

        // 生成文件
        const buffer = XLSX.write(wb, { type: 'array' })
        const blob = new Blob([buffer], { type: 'application/octet-stream' })
        FileSaver.saveAs(blob, `广告数据_${new Date().toISOString().slice(0, 10)}.xlsx`)

      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + error.message)
      }
    },
    exportExcel2() {
      const XLSX = require('xlsx')
      const FileSaver = require('file-saver')

      // 完整列配置（必须与表格列顺序严格一致）
      const columns = [
        { label: '广告主ID', key: 'id' },
        { label: '广告主名称', key: 'account' },
        { label: '广告主账号', key: 'display_name' },
        { label: '行业分类', key: 'category' },
        { label: '所属子账户', key: 'belongs' },
        { label: '展现数', key: 'impression' },
        { label: '点击数', key: 'click' },
        {
          label: '点击率',
          format: (row) => {
            const click = Number(row.click) || 0
            const impression = Number(row.impression) || 0
            return impression ? ((click / impression) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '总消费',
          format: (row) => (Number(row.cost) / 100).toFixed(2)
        },
        {
          label: '现金消费',
          format: (row) => (Number(row.cash) / 100).toFixed(2)
        },
        {
          label: '优惠券消费',
          format: (row) => (Number(row.coupon) / 100).toFixed(2)
        },
        {
          label: '点击单价',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const click = Number(row.click) || 0
            return click ? (cost / click).toFixed(2) : 0.00
          }
        },
        {
          label: '千次展现消费',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const impression = Number(row.impression) || 0
            return impression ? ((cost / impression) * 1000).toFixed(2) : 0.00
          }
        },
        // 转化目标相关列
        { label: '转化目标总数', key: 'api_conversion_target' },
        {
          label: '转化目标总数转化率',
          format: (row) => {
            const target = Number(row.api_conversion_target) || 0
            const click = Number(row.click) || 0
            return click ? ((target / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '转化目标总数成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const target = Number(row.api_conversion_target) || 0
            return target ? (cost / target).toFixed(2) : 0.00
          }
        },
        // 激活相关列
        { label: '激活数', key: 'api_app_active' },
        {
          label: '激活转化率',
          format: (row) => {
            const active = Number(row.api_app_active) || 0
            const click = Number(row.click) || 0
            return click ? ((active / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '激活成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const active = Number(row.api_app_active) || 0
            return active ? (cost / active).toFixed(2) : 0.00
          }
        },
        // 首次拉活相关列
        { label: '首次拉活', key: 'api_app_lahuo' },
        {
          label: '首次拉活转化率',
          format: (row) => {
            const lahuo = Number(row.api_app_lahuo) || 0
            const click = Number(row.click) || 0
            return click ? ((lahuo / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '首次拉活成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const lahuo = Number(row.api_app_lahuo) || 0
            return lahuo ? (cost / lahuo).toFixed(2) : 0.00
          }
        },
        // 关键行为相关列
        { label: '关键行为', key: 'api_app_keyaction' },
        {
          label: '关键行为转化率',
          format: (row) => {
            const action = Number(row.api_app_keyaction) || 0
            const click = Number(row.click) || 0
            return click ? ((action / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '关键行为成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const action = Number(row.api_app_keyaction) || 0
            return action ? (cost / action).toFixed(2) : 0.00
          }
        },
        // 次留相关列
        { label: '次留', key: 'api_app_retention' },
        {
          label: '次留率',
          format: (row) => {
            const retention = Number(row.api_app_retention) || 0
            const click = Number(row.click) || 0
            return click ? ((retention / click) * 100).toFixed(2) + '%' : '0.00%'
          }
        },
        {
          label: '次留成本',
          format: (row) => {
            const cost = Number(row.cost) / 100 || 0
            const retention = Number(row.api_app_retention) || 0
            return retention ? (cost / retention).toFixed(2) : 0.00
          }
        }
      ]

      const flatten = (data) => {
        return data.reduce((acc, item) => {
          acc.push(item);
          return acc;
        }, []);
      };

      try {
        if (!this.responseResultslistchildren.length) {
          this.$message.warning('没有可导出的数据')
          return
        }

        // 处理数据行
        const data = flatten(this.responseResultslistchildren).map(row =>
          columns.reduce((obj, col) => {
            let value = col.format
              ? col.format(row)
              : row[col.key]

            // 统一处理特殊字符
            if (typeof value === 'string') {
              value = value
                .replace(/"/g, '""')
                .replace(/[\r\n]/g, ' ')
            }

            // 确保非百分比数字值以数字形式存储
            if (typeof value === 'string' && !value.includes('%') && !isNaN(value) && value.trim() !== '') {
              value = Number(value);
            }

            obj[col.label] = value
            return obj
          }, {})
        )

        // 生成工作表
        const ws = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '广告数据')

        // 设置列宽
        ws['!cols'] = columns.map(() => ({ wch: 18 }))

        // 生成文件
        const buffer = XLSX.write(wb, { type: 'array' })
        const blob = new Blob([buffer], { type: 'application/octet-stream' })
        FileSaver.saveAs(blob, `广告数据_${new Date().toISOString().slice(0, 10)}.xlsx`)

      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + error.message)
      }
    },
    // exportExcel2() {
    //   const XLSX = require('xlsx')
    //   const FileSaver = require('file-saver')

    //   // 完整列配置（必须与表格列顺序严格一致）
    //   const columns = [
    //     { label: '广告主ID', key: 'id' },
    //     { label: '广告主名称', key: 'account' },
    //     { label: '广告主账号', key: 'display_name' },
    //     { label: '行业分类', key: 'category' },
    //     { label: '所属子账户', key: 'belongs' },
    //     { label: '展现数', key: 'impression' },
    //     { label: '点击数', key: 'click' },
    //     {
    //       label: '点击率',
    //       format: (row) => {
    //         const click = Number(row.click) || 0
    //         const impression = Number(row.impression) || 0
    //         return impression ? `${((click / impression) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '总消费',
    //       format: (row) => `￥${(Number(row.cost) / 100).toFixed(2)}`
    //     },
    //     {
    //       label: '现金消费',
    //       format: (row) => `￥${(Number(row.cash) / 100).toFixed(2)}`
    //     },
    //     {
    //       label: '优惠券消费',
    //       format: (row) => `￥${(Number(row.coupon) / 100).toFixed(2)}`
    //     },
    //     {
    //       label: '点击单价',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const click = Number(row.click) || 0
    //         return click ? `￥${(cost / click).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     {
    //       label: '千次展现消费',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const impression = Number(row.impression) || 0
    //         return impression ? `￥${((cost / impression) * 1000).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     // 转化目标相关列
    //     { label: '转化目标总数', key: 'api_conversion_target' },
    //     {
    //       label: '转化目标总数转化率',
    //       format: (row) => {
    //         const target = Number(row.api_conversion_target) || 0
    //         const click = Number(row.click) || 0
    //         return click ? `${((target / click) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '转化目标总数成本',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const target = Number(row.api_conversion_target) || 0
    //         return target ? `￥${(cost / target).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     // 激活相关列
    //     { label: '激活数', key: 'api_app_active' },
    //     {
    //       label: '激活转化率',
    //       format: (row) => {
    //         const active = Number(row.api_app_active) || 0
    //         const click = Number(row.click) || 0
    //         return click ? `${((active / click) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '激活成本',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const active = Number(row.api_app_active) || 0
    //         return active ? `￥${(cost / active).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     // 首次拉活相关列
    //     { label: '首次拉活', key: 'api_app_lahuo' },
    //     {
    //       label: '首次拉活转化率',
    //       format: (row) => {
    //         const lahuo = Number(row.api_app_lahuo) || 0
    //         const click = Number(row.click) || 0
    //         return click ? `${((lahuo / click) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '首次拉活成本',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const lahuo = Number(row.api_app_lahuo) || 0
    //         return lahuo ? `￥${(cost / lahuo).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     // 关键行为相关列
    //     { label: '关键行为', key: 'api_app_keyaction' },
    //     {
    //       label: '关键行为转化率',
    //       format: (row) => {
    //         const action = Number(row.api_app_keyaction) || 0
    //         const click = Number(row.click) || 0
    //         return click ? `${((action / click) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '关键行为成本',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const action = Number(row.api_app_keyaction) || 0
    //         return action ? `￥${(cost / action).toFixed(2)}` : '￥0.00'
    //       }
    //     },
    //     // 次留相关列
    //     { label: '次留', key: 'api_app_retention' },
    //     {
    //       label: '次留率',
    //       format: (row) => {
    //         const retention = Number(row.api_app_retention) || 0
    //         const click = Number(row.click) || 0
    //         return click ? `${((retention / click) * 100).toFixed(2)}%` : '0.00%'
    //       }
    //     },
    //     {
    //       label: '次留成本',
    //       format: (row) => {
    //         const cost = Number(row.cost) / 100 || 0
    //         const retention = Number(row.api_app_retention) || 0
    //         return retention ? `￥${(cost / retention).toFixed(2)}` : '￥0.00'
    //       }
    //     }
    //   ]

    //   // 递归展开树形数据
    //   // const flatten = (data) => data.reduce((acc, item) => {
    //   //   acc.push(item)
    //   //   return item.children ? acc.concat(flatten(item.children)) : acc
    //   // }, [])

    //   const flatten = (data) => {
    //     return data.reduce((acc, item) => {
    //       acc.push(item); // 直接添加当前元素
    //       return acc; // 无需处理children
    //     }, []);
    //   };

    //   try {
    //     if (!this.responseResultslistchildren.length) {
    //       this.$message.warning('没有可导出的数据')
    //       return
    //     }

    //     // 处理数据行
    //     const data = flatten(this.responseResultslistchildren).map(row =>
    //       columns.reduce((obj, col) => {
    //         let value = col.format
    //           ? col.format(row)
    //           : row[col.key]

    //         // 统一处理特殊字符
    //         if (typeof value === 'string') {
    //           value = value
    //             .replace(/"/g, '""')
    //             .replace(/[\r\n]/g, ' ')
    //         }

    //         obj[col.label] = value
    //         return obj
    //       }, {})
    //     )

    //     // 生成工作表
    //     const ws = XLSX.utils.json_to_sheet(data)
    //     const wb = XLSX.utils.book_new()
    //     XLSX.utils.book_append_sheet(wb, ws, '广告数据')

    //     // 设置列宽
    //     ws['!cols'] = columns.map(() => ({ wch: 18 }))

    //     // 生成文件
    //     const buffer = XLSX.write(wb, { type: 'array' })
    //     const blob = new Blob([buffer], { type: 'application/octet-stream' })
    //     FileSaver.saveAs(blob, `广告数据_${new Date().toISOString().slice(0, 10)}.xlsx`)

    //   } catch (error) {
    //     console.error('导出失败:', error)
    //     this.$message.error('导出失败：' + error.message)
    //   }
    // },
    async fetchCookieData() {
      this.responseResultslist = []
      this.loading = true;
      try {
        // 获取实际需要处理的对象数组
        const targets = this.selectedOptions;


        try {
          const requests2 = targets.map((item, index) => {
            console.log(item.qttcookie);
            if (item.qttcookie === '') {
              this.$message.warning('账号' + item.qttuname + '需要去刷新登录状态')
              return false
            }
            return axios.get('https://control.zjwec.cn/api/qtt/agentData', {
              params: {
                cookie: item.qttcookie,
                beginTime: this.formatDate(this.value1[0]),
                endTime: this.formatDate(this.value1[1])
              }
            })

          }

          );

          // 等待所有请求完成
          const responses3 = await Promise.all(requests2);

          // 确保 responseResultslist 是数组，并合并新数据
          // this.responseResultslist = responses3.reduce((acc, item) => {
          //   console.log(acc);
          //   console.log(item);
          //   const data = item.data.data || []; // 防止 item.data.data 是 null/undefined
          //   return [...acc, ...data];
          // }, this.responseResultslist || []); // 如果 this.responseResultslist 是 null，默认空数组
          this.responseResultslist = responses3.reduce((acc, item) => {
            const data = item.data.data || [];

            const processedData = data.map(item => {
              // 提取基础数据（添加默认值防止 NaN）
              const click = item.click || 0;
              const impression = item.impression || 0;
              const cost = item.cost || 0; // 单位：分
              const cash = item.cash || 0; // 新增：现金消费（单位：分）
              const uid = `${item.id}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

              // 计算点击率（百分比）
              const clickThroughRate = click === 0 || impression === 0
                ? "0.00"
                : ((click / impression) * 100).toFixed(2);

              // 计算点击单价（元/次）
              const clickOnPrice = click === 0
                ? "0.00"
                : ((cost / 100) / click).toFixed(2);

              // 计算千次展现消费（元/千次）
              const thousandImpressionsConsumption = impression === 0
                ? "0.00"
                : ((cost / 100) / impression * 1000).toFixed(2); // 转换为元

              // 新增：计算总消费（元）
              const totalConsumption = (cost / 100).toFixed(2);

              // 新增：计算现金消费（元）
              const cashConsumption = (cash / 100).toFixed(2);
              return {
                ...item,
                uid,
                click_through_rate: clickThroughRate,           // 点击率（字符串，百分比）
                click_onprice: clickOnPrice,                   // 点击单价（字符串，元/次）
                thousand_impressions_consumption: thousandImpressionsConsumption, // 千次展现消费（字符串，元/千次）
                total_consumption: totalConsumption,      // 新增：总消费（元）
                cash_consumption: cashConsumption        // 新增：现金消费（元）
              };
            });

            return [...acc, ...processedData];
          }, this.responseResultslist || []);

          // 计算统计数据
          let impression = 0;
          let click = 0;
          let cost = 0;
          let cash = 0;
          let coupon = 0;
          let api_conversion_target = 0;
          let api_conversion_target_rate = 0;
          let api_conversion_target_cost = 0;
          let api_app_active = 0;
          let api_app_active_rate = 0;
          let api_app_active_cost = 0;
          let api_app_lahuo = 0;
          let api_app_lahuo_rate = 0;
          let api_app_lahuo_cost = 0;
          let api_app_keyaction = 0;
          let api_app_keyaction_rate = 0;
          let api_app_keyaction_cost = 0;
          let api_app_retention = 0;
          let api_app_retention_rate = 0;
          let api_app_retention_cost = 0;


          this.responseResultslist.forEach((item) => {
            cost += parseFloat(item.cost) || 0;
            cash += parseFloat(item.cash) || 0;
            coupon += parseFloat(item.coupon) || 0;
            click += parseInt(item.click) || 0;
            impression += parseInt(item.impression) || 0;

            api_conversion_target += parseInt(item.api_conversion_target) || 0;
            api_conversion_target_rate += parseInt(item.api_conversion_target_rate) || 0;
            api_conversion_target_cost += parseInt(item.api_conversion_target_cost) || 0;
            api_app_active += parseInt(item.api_app_active) || 0;
            api_app_active_rate += parseInt(item.api_app_active_rate) || 0;
            api_app_active_cost += parseInt(item.api_app_active_cost) || 0;
            api_app_lahuo += parseInt(item.api_app_lahuo) || 0;
            api_app_lahuo_rate += parseInt(item.api_app_lahuo_rate) || 0;
            api_app_lahuo_cost += parseInt(item.api_app_lahuo_cost) || 0;
            api_app_keyaction += parseInt(item.api_app_keyaction) || 0;
            api_app_keyaction_rate += parseInt(item.api_app_keyaction_rate) || 0;
            api_app_keyaction_cost += parseInt(item.api_app_keyaction_cost) || 0;
            api_app_retention += parseInt(item.api_app_retention) || 0;
            api_app_retention_rate += parseInt(item.api_app_retention_rate) || 0;
            api_app_retention_cost += parseInt(item.api_app_retention_cost) || 0;
          });
          const clickThroughRate = click === 0 || impression === 0 ? "0.00" : ((click / impression) * 100).toFixed(2);
          // 计算点击单价（元/次）
          const clickOnPrice = click === 0 ? "0.00" : ((cost / 100) / click).toFixed(2);
          // 计算千次展现消费（元/千次）
          const thousandImpressionsConsumption = impression === 0 ? "0.00" : ((cost / 100) / impression * 1000).toFixed(2); // 转换为元
          const totalConsumption = (cost / 100).toFixed(2);

          // 新增：计算现金消费（元）
          const cashConsumption = (cash / 100).toFixed(2);
          this.responseResultslistchildren = [
            {
              id: "-", account: "-", display_name: "总计", category: "-", belongs: "-", impression, click, cost, cash, coupon,
              api_conversion_target,
              api_conversion_target_rate,
              api_conversion_target_cost,
              api_app_active,
              api_app_active_rate,
              api_app_active_cost,
              api_app_lahuo,
              api_app_lahuo_rate,
              api_app_lahuo_cost,
              api_app_keyaction,
              api_app_keyaction_rate,
              api_app_keyaction_cost,
              api_app_retention,
              api_app_retention_rate,
              api_app_retention_cost,
              click_through_rate: clickThroughRate,
              click_onprice: clickOnPrice,
              thousand_impressions_consumption: thousandImpressionsConsumption,
              total_consumption: totalConsumption,      // 新增：总消费（元）
              cash_consumption: cashConsumption

            },
            ...this.responseResultslist
          ];
          if (this.value == "子账户") {
            this.responseResultslist = this.responseResultslistchildren
            return
          }
          let children = this.groupAndStatistic(this.responseResultslist);
          console.log(children);

          // 更新 responseResultslist
          console.log(api_conversion_target_rate,
            api_conversion_target_cost,
            api_app_active,
            api_app_active_rate,
            api_app_active_cost,
            api_app_lahuo,
            api_app_lahuo_rate,
            api_app_lahuo_cost,
            api_app_keyaction,
            api_app_keyaction_rate,
            api_app_keyaction_cost,
            api_app_retention,
            api_app_retention_rate,
            api_app_retention_cost);
          this.responseResultslist = [
            {
              id: "-", account: "-", display_name: "总计", category: "-", belongs: "-", impression, click, cost, cash, coupon, api_conversion_target,
              api_conversion_target_rate,
              api_conversion_target_cost,
              api_app_active,
              api_app_active_rate,
              api_app_active_cost,
              api_app_lahuo,
              api_app_lahuo_rate,
              api_app_lahuo_cost,
              api_app_keyaction,
              api_app_keyaction_rate,
              api_app_keyaction_cost,
              api_app_retention,
              api_app_retention_rate,
              api_app_retention_cost,
              click_through_rate: clickThroughRate,
              click_onprice: clickOnPrice,
              thousand_impressions_consumption: thousandImpressionsConsumption,
              total_consumption: totalConsumption,      // 新增：总消费（元）
              cash_consumption: cashConsumption
            },
            ...children,
          ];



          console.log(responses3);
          console.log(this.responseResultslistchildren);
        } catch (error) {
          console.log(error);
        }

        console.log('所有请求完成:', this.responseResults);

      } catch (error) {
        console.error('请求失败:', error);
        this.$message.error('部分请求失败，请检查网络或配置');
      } finally {
        this.loading = false;
      }
    },
    groupAndStatistic(data) {
      const group = {};

      data.forEach(item => {
        const belongsKey = item.belongs;

        if (!group[belongsKey]) {
          group[belongsKey] = {
            id: `group_${belongsKey}`,  // 确保ID唯一
            uid: `${belongsKey}_${Date.now()}_${Math.floor(Math.random() * 1000)}`,
            account: "-",
            display_name: "分组总计",
            category: "-",
            belongs: belongsKey,
            impression: 0,
            click: 0,
            cost: 0,
            cash: 0,
            coupon: 0,
            click_through_rate: 0,
            click_onprice: 0,
            thousand_impressions_consumption: 0,
            api_conversion_target: 0,
            api_conversion_target_rate: 0,
            api_conversion_target_cost: 0,
            api_app_active: 0,
            api_app_active_rate: 0,
            api_app_active_cost: 0,
            api_app_lahuo: 0,
            api_app_lahuo_rate: 0,
            api_app_lahuo_cost: 0,
            api_app_keyaction: 0,
            api_app_keyaction_rate: 0,
            api_app_keyaction_cost: 0,
            api_app_retention: 0,
            api_app_retention_rate: 0,
            api_app_retention_cost: 0,
            total_consumption: 0,      // 新增：总消费（元）
            cash_consumption: 0,
            children: [],  // 这里必须是 children 字段
          };
        }

        // 累加统计
        group[belongsKey].impression += item.impression;
        group[belongsKey].click += item.click;
        group[belongsKey].cost += item.cost;
        group[belongsKey].cash += item.cash;
        group[belongsKey].coupon += item.coupon;
        group[belongsKey].click_through_rate = group[belongsKey].click === 0 || group[belongsKey].impression === 0 ? "0.00" : ((group[belongsKey].click / group[belongsKey].impression) * 100).toFixed(2);
        // 计算点击单价（元/次）
        group[belongsKey].click_onprice = group[belongsKey].click === 0 ? "0.00" : ((group[belongsKey].cost / 100) / group[belongsKey].click).toFixed(2);
        // 计算千次展现消费（元/千次）
        group[belongsKey].thousand_impressions_consumption = group[belongsKey].impression === 0 ? "0.00" : ((group[belongsKey].cost / 100) / group[belongsKey].impression * 1000).toFixed(2); // 转换为元
        group[belongsKey].total_consumption = (group[belongsKey].cost / 100).toFixed(2);

        group[belongsKey].cash_consumption = (group[belongsKey].cash / 100).toFixed(2);

        group[belongsKey].api_conversion_target += item.api_conversion_target;
        group[belongsKey].api_conversion_target_rate += item.api_conversion_target_rate;
        group[belongsKey].api_conversion_target_cost += item.api_conversion_target_cost;
        group[belongsKey].api_app_active += item.api_app_active;
        group[belongsKey].api_app_active_rate += item.api_app_active_rate;
        group[belongsKey].api_app_active_rate += item.api_app_active_rate;
        group[belongsKey].api_app_lahuo += item.api_app_lahuo;
        group[belongsKey].api_app_lahuo_rate += item.api_app_lahuo_rate;
        group[belongsKey].api_app_lahuo_cost += item.api_app_lahuo_cost;
        group[belongsKey].api_app_keyaction += item.api_app_keyaction;
        group[belongsKey].api_app_keyaction_rate += item.api_app_keyaction_rate;
        group[belongsKey].api_app_keyaction_cost += item.api_app_keyaction_cost;
        group[belongsKey].api_app_retention += item.api_app_retention;
        group[belongsKey].api_app_retention_rate += item.api_app_retention_rate;
        group[belongsKey].api_app_retention_cost += item.api_app_retention_cost;


        // 添加子项（原数据）
        group[belongsKey].children.push({
          ...item,
          id: item.id   // 确保子项ID与父项不同
        });
      });

      return Object.values(group);
    },


    getUlist() {
      axios.get('https://control.zjwec.cn/api/qtt/list', {
        params: { khname: this.verificationCode, userid: this.userId }
      }).then(response => {
        console.log(response.data);
        this.clientList = response.data
      })
    },
    handleSelectChange(selectedItems) {
      // 检查是否点击了全选选项
      const hasSelectAll = selectedItems.some(item => item.isSelectAll);

      // 检查是否所有选项都被选中了（不包括全选选项）
      const allSelected = selectedItems.filter(item => !item.isSelectAll).length === this.clientList.length;

      if (hasSelectAll) {
        // 如果选择了"不限"，则选中所有客户（排除全选选项本身）
        this.selectedOptions = [...this.clientList];
      } else if (allSelected) {
        // 如果手动选中了所有客户，自动转换为"不限"状态
        this.selectedOptions = [...this.clientList];
      } else {
        // 正常情况更新选中项（过滤掉可能存在的全选选项）
        this.selectedOptions = selectedItems.filter(item => !item.isSelectAll);
      }
    },

    getsrcuel() {
      axios.get('https://login.aiclk.com/get/captcha', {
        responseType: 'blob',
        params: { timestamp: Date.now() }
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'image/png' });
          this.srcurl = URL.createObjectURL(blob);
          // console.log(this.captchaUrl);
          // ...
        })
        .catch(error => {
          console.error('获取验证码失败:', error);
          // ...
        })
        .finally(() => {
          // this.loading = false;
        });
    },

  },
};
</script>

<style scoped>
.select-container {
  margin: 0 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/yzm.vue